import { Text } from '@audio-network/componentlibrary';
import styled from 'styled-components';
import BaseSlider from '../Slider/Slider';
export var WaveformContainer = styled.div.withConfig({
  displayName: "PlayerWaveformstyles__WaveformContainer",
  componentId: "sc-1wa8559-0"
})(["display:grid;grid-area:wave;width:100%;grid-template-areas:'waveform waveform waveform';grid-template-rows:1fr;grid-template-columns:auto 1fr auto;align-items:center;justify-content:center;", "{max-width:72rem;top:0;gap:0.5rem;grid-template-areas:'time waveform duration';grid-template-columns:auto 1fr auto;grid-template-rows:auto;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var Time = styled(Text).withConfig({
  displayName: "PlayerWaveformstyles__Time",
  componentId: "sc-1wa8559-1"
})(["grid-area:time;font-variant-numeric:tabular-nums;padding-right:1rem;display:none;", "{display:block;padding-right:0;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var Waveform = styled.div.withConfig({
  displayName: "PlayerWaveformstyles__Waveform",
  componentId: "sc-1wa8559-2"
})(["display:none;grid-area:waveform;position:relative;height:100%;top:-10px;margin:0 -1rem;justify-content:center;align-items:center;& > div[role='slider']{display:none;}", "{display:block;margin:0;top:0;& > div[role='slider']{display:block;}}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var Duration = styled(Text).withConfig({
  displayName: "PlayerWaveformstyles__Duration",
  componentId: "sc-1wa8559-3"
})(["grid-area:duration;font-variant-numeric:tabular-nums;display:none;", "{display:block;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var WaveformImage = styled.img.withConfig({
  displayName: "PlayerWaveformstyles__WaveformImage",
  componentId: "sc-1wa8559-4"
})(["display:", ";height:100%;image-rendering:pixelated;inset:0;width:100%;"], function (_ref) {
  var src = _ref.src;
  return src ? 'initial' : 'none';
});
export var Slider = styled(BaseSlider).withConfig({
  displayName: "PlayerWaveformstyles__Slider",
  componentId: "sc-1wa8559-5"
})(["position:absolute;top:0;left:0;width:100%;height:2px;padding:0;margin:0;cursor:default;&[type='range']{height:2px;background:rgba(255,255,255,0.2);border-radius:0;background-image:linear-gradient(#ffffff,#ffffff);background-repeat:no-repeat;}&[type='range']::-webkit-slider-thumb{visibility:hidden !important;opacity:0 !important;}&[type='range']::-moz-range-thumb{visibility:hidden !important;opacity:0 !important;}", "{&&&{display:none;}}"], function (props) {
  return props.theme.breakpoints.tablet;
});
export var ProgressBarContainer = styled.div.withConfig({
  displayName: "PlayerWaveformstyles__ProgressBarContainer",
  componentId: "sc-1wa8559-6"
})(["grid-area:waveform;width:100%;height:0.125rem;background-color:", ";position:absolute;inset:0 0 auto;", "{display:none;}"], function (props) {
  return props.theme.colors.ui4;
}, function (props) {
  return props.theme.breakpoints.tablet;
});
export var ProgressBar = styled.div.withConfig({
  displayName: "PlayerWaveformstyles__ProgressBar",
  componentId: "sc-1wa8559-7"
})(["width:0;height:inherit;background-color:", ";"], function (props) {
  return props.theme.colors.ui1;
});